import { AmplitudeEventProperty, logAmplitudeEvent } from 'chairisher/util/analytics';

const PRICE_UNDER_1500 = '-1500';
const PRICE_UNDER_2500 = '-2500';

/**
 * Accepts an individual category link and its display text, then builds amplitudeEventObject to track the `link - click` event.
 *
 * @param {Element} link
 * @param {string} text
 */
function logLandingContentLinkClick(link, text) {
    const amplitudeEventObject = {};
    amplitudeEventObject[AmplitudeEventProperty.CTA_NAME] = text;

    const section = link.closest('[data-landing-section]');
    amplitudeEventObject[AmplitudeEventProperty.CTA_POSITION] = section.getAttribute('data-landing-section');

    logAmplitudeEvent('link - click', amplitudeEventObject);
}

/**
 * Attaches logLandingContentLinkClick() to each of the new elements added at the top of the landing page
 */
export function trackCategoryLinks() {
    const links = document.querySelectorAll('.js-landing-link');
    links.forEach((link) => {
        const text = link.textContent.trim();
        link.addEventListener('click', () => {
            logLandingContentLinkClick(link, text);
        });
    });
}

/**
 * Scrolls the page to the search results if a price filter is present in the URL.
 *
 * Top categories behavior: When a user clicks "Jewelry Under $1,500" or "Furniture Under $2,500" on the landing content,
 * the page reloads with a price filter (?price=-2500 or ?price=-1500) but stays at the top, which can be confusing.
 * This function checks for those price params and automatically scrolls to the results section (id="js-search-form")
 * so users immediately see the filtered results.
 *
 */
export function scrollToResultsIfNeeded() {
    function scrollIfNeeded() {
        const params = new URLSearchParams(window.location.search);
        const price = params.get('price');
        if (price === PRICE_UNDER_1500 || price === PRICE_UNDER_2500) {
            const resultsEl = document.getElementById('js-search-form');
            if (resultsEl) {
                resultsEl.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scrollIfNeeded);
    } else {
        scrollIfNeeded();
    }
}
